<div
  class="admin-section-header"
  [class.admin-section-header__readonly]="client"
  [class.collapsed]="executionCollapsed"
  [class.delayed]="subProject.delayed"
>
  <div
    [class.collapsed]="executionCollapsed"
    class="d-flex"
    (click)="toggleCollapse()"
  >
    <div class="d-flex">
      <ng-container
        *ngIf="
          isRepoNotByInpress || isNotInstalledByInpress;
          else collapseableDisplay
        "
      >
        <span
          >Uitgevoerd door klant
          <b
            >({{ subProject.currentCreatedAt | date : 'dd/MM/yyyy' }} -
            {{
              subProject.projectUser != null
                ? (subProject.projectUser?.firstName
                  | personName : subProject.projectUser?.lastName)
                : 'klant'
            }})</b
          >
        </span>
        <impersonate-icon *ngIf="!client" [user]="subProject.projectUser">
        </impersonate-icon>
      </ng-container>
      <ng-template #collapseableDisplay>
        Uitvoering
        <ng-container
          *ngIf="
            notExecutedHistoryItem?.handled === false;
            else showTourConfigurationDisplay
          "
        >
          <b class="ml-2">(niet uitgevoerd)</b>
        </ng-container>
        <ng-template #showTourConfigurationDisplay>
          <ng-container *ngIf="subProject.delayed; else tourData">
            <b class="ml-1">UITGESTELD!</b>
          </ng-container>
          <ng-template #tourData>
            <b class="ml-2"
              >({{
                tourConfigurationDisplay?.length > 0
                  ? tourConfigurationDisplay
                  : 'datum - Installateur'
              }})</b
            >
            <impersonate-icon
              *ngIf="!client && placer != null"
              [user]="placer?.user"
            >
            </impersonate-icon>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>
    <div class="admin-section-arrow">
      <div *ngIf="!client && !isRepoNotByInpress && !isNotInstalledByInpress">
        <button mat-icon-button>
          <mat-icon class="admin-section-arrow-icon"> arrow_drop_up </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="!client"
  class="collapsible-content"
  [collapse]="executionCollapsed"
  [isAnimated]="!safari"
  [class.delayed]="subProject.delayed"
>
  <div class="collapse-content-container execution-collapse-content">
    <mat-card
      *ngIf="notExecutedHistoryItem == null || notExecutedHistoryItem.handled"
      class="top-card mat-elevation-z0 overflowHidden"
    >
      <ip-board-tour-selector
        *ngIf="subProject.id != null"
        [subProject]="subProject"
        [tourUnassigned]="tourUnassigned"
      ></ip-board-tour-selector>
      <div
        *ngIf="
          firstProductBoardPart != null &&
          (firstProductBoardPart.originalBoardType != null ||
            firstProductBoardPart.originalPlacementType != null)
        "
        class="d-flex mb-3"
      >
        <span>(</span>
        <strong class="mr-1 ml-1">Configuratie aangepast:</strong>
        <span class="mr-1 ml-2">{{
          firstProductBoardPart?.originalBoardType?.label +
            ' - ' +
            firstProductBoardPart?.originalPlacementType?.label
        }}</span>
        <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
        <span
          >{{
            firstProductBoardPart?.boardType?.label +
              ' - ' +
              firstProductBoardPart?.placementType?.label
          }}
          )</span
        >
      </div>
      <ip-board-executed
        [project]="project"
        [subProject]="subProject"
        [products]="project.products"
        (save)="save.emit()"
      ></ip-board-executed>
      <ip-board-delay
        [subProject]="subProject"
        (save)="save.emit()"
        (delayed)="delayedChanged($event)"
      ></ip-board-delay>
    </mat-card>
    <ng-container
      *ngIf="
        notExecutedHistoryItem != null &&
        (!client || !notExecutedHistoryItem.handled)
      "
    >
      <display-not-executed-history-item
        [notExecutedHistoryItem]="notExecutedHistoryItem"
        [project]="project"
        [subProject]="subProject"
        [useMatCard]="true"
        [title]="notExecutedHistoryItem.handled ? 'Info niet uitgevoerd' : ''"
        [displayOnly]="client || notExecutedHistoryItem.handled"
        [editable]="!client"
        [divergentPricesOnly]="divergentPricesOnly"
      ></display-not-executed-history-item>
    </ng-container>
  </div>
</div>
